var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from 'react';
import { StarRating } from '../../StarRating';
import { TextLink } from '../../TextLink';
import { Typography } from '../../../foundations/typography';
import styles from './Rating.module.scss';
var MINIMUM_NUMBER_OF_REVIEWS = 1;
export var Rating = memo(function (_a) {
    var reviews = _a.reviews, textLinkProps = __rest(_a, ["reviews"]);
    var hasRequiredReviews = reviews.reviewCount >= MINIMUM_NUMBER_OF_REVIEWS;
    var showLink = hasRequiredReviews && (textLinkProps === null || textLinkProps === void 0 ? void 0 : textLinkProps.href);
    // TODO: this should be defined as a separate, first class component
    // accepting props for `hasRequiredReviews` etc.
    // Defining this without memoization means it will be re-created _every_
    // render of every `Rating` component.
    // eslint-disable-next-line react/no-unstable-nested-components
    var StarsWithReviewCount = function () {
        return (React.createElement(StarRating, { noReviews: !hasRequiredReviews, rating: reviews.averageRating, "data-testid": "star-rating" },
            React.createElement(Typography, { element: "span", noMargins: true, "data-testid": "review-count" },
                "(",
                reviews.reviewCount,
                ")")));
    };
    var RatingWrapper = showLink ? (React.createElement(TextLink, __assign({ underline: "hover" }, textLinkProps), StarsWithReviewCount())) : (StarsWithReviewCount());
    return React.createElement("div", { className: styles.rating }, RatingWrapper);
});
//# sourceMappingURL=Rating.js.map